module.exports = __webpack_public_path__ + "img/img-kiosk-step-02.png";